import add from './add.js'
import addButton from './add-button'
import card from './card'
import comment from './comment'
import list from './list'
import overlay from './overlay'

export default {
    add,
    addButton,
    card,
    comment,
    list,
    overlay
}
